import { reactive } from "vue";

export const clientConfig = reactive({
  preset_contact: process.env.VUE_APP_PRESET_CONTACT || "",
  preset_contact_hint: process.env.VUE_APP_PRESET_CONTACT_HINT || "",
  preset_id_reg_info: process.env.VUE_APP_PRESET_ID_REG_INFO || "",
  preset_id_reg_more_info: process.env.VUE_APP_PRESET_ID_REG_MORE_INFO || "",
  preset_error_message_validation: process.env.VUE_APP_PRESET_ERROR_MESSAGE_VALIDATION || "",
});

export async function loadClientConfig() {
  try {
    const res = await fetch(`${process.env.VUE_APP_BACKEND_URL}/v1/client-config`);
    if (!res.ok) return;
    const data = await res.json();
    Object.assign(clientConfig, data);
  } catch (e) {
    console.warn("Could not load client config from server, using .env defaults.", e);
  }
}
